/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ApproveAddVcDialog.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { adminSettingsAPI, HandleApiActions } from "../../redux/actions";
import { Box, Stack } from "@mui/material";
import CustomDialogBoxV2 from "../customComponentsV2/common/customDialogBox/CustomDialogBoxV2";
import CustomFormTextFieldV2 from "../customComponentsV2/common/textField/CustomFormTextFieldV2";

function ApproveAddVcDialog({
  openDialog,
  setOpenDialog,
  title,
  selectedAddVcId,
  setSelectedAddVcId,
  getVcAddRequests,
}) {
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");


  const getAdminVehicleSystems = () => {
    const apiDetails = adminSettingsAPI.get_vehicle_systems;
    dispatch(
      HandleApiActions({
        ...apiDetails,
      }),
    );
  };
  const approveAddVCRequest = () => {
    const apiDetails = adminSettingsAPI.approve_add_vc_request;
    dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: true,
        params: {
          id: Number(selectedAddVcId),
          reason,
        },
      }),
    ).then((resp) => {
      if (!resp?.error) {
        handleCloseDialog();
        getVcAddRequests();
        getAdminVehicleSystems();
      }
    });
  };

  const isDialogFieldsValid = () => {
    return reason?.trim() !== "" && !reasonError;
  };
  const clearDialogFields = () => {
    setReason("");
    setReasonError("");
    setSelectedAddVcId(null);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    clearDialogFields();
  };

  return (
    <CustomDialogBoxV2
      open={openDialog}
      onClose={handleCloseDialog}
      title={title}
      onDisabled={!isDialogFieldsValid()}
      successButtonName={"Confirm"}
      rejectButtonName={"Close"}
      onClickSuccess={approveAddVCRequest}
      actionButtonStyle={"continuous"}
      onClickReject={handleCloseDialog}
    >
      <Stack spacing={1.2} sx={{ width: "350px" }}>
        <Box>
          <CustomFormTextFieldV2
            required={true}
            label={"Reason"}
            value={reason}
            setValue={(val) => {
              if (val.length <= 100) {
                setReason(val);
              }
            }}
            maxLength={100}
          />
        </Box>
      </Stack>
    </CustomDialogBoxV2>
  );
}

ApproveAddVcDialog.propTypes = {
  openDialog: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  title: PropTypes.string,
  selectedAddVcId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedAddVcId: PropTypes.func,
  getVcAddRequests: PropTypes.func,
};

ApproveAddVcDialog.defaultProps = {
  openDialog: false,
  setOpenDialog: () => {},
  title: "",
  selectedAddVcId: null,
  setSelectedAddVcId: () => {},
  getVcAddRequests: () => {},
};

export default ApproveAddVcDialog;

